import React from "react";
import { PalletsReclasificacion } from "../../../../../components/PalletsReclasificacion/PalletsReclasificacion";
import { formatDisplayNumber } from "../../../../../../../../../../utility/utils";

const SeccionReclasificacion = ({ reclasificacion }) => {
    return (
        <div className="d-flex flex-column w-100 gap-10">
            <h5 className="text-sm">Pacas en reclasificación</h5>

            <div className="formulario-fields-row w-100 gap-1rem flex-wrap my-0">
                <div className="formulario-field">
                    <label className="text-nowrap">Pacas agregadas</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={formatDisplayNumber(reclasificacion.pacas)}
                    />
                </div>
                <div className="formulario-field">
                    <label className="text-nowrap">
                        Pallets utilizados
                    </label>
                    <div className="w-auto">
                        <PalletsReclasificacion
                            pallets={reclasificacion.pallets}
                            align="start"
                        />
                    </div>
                </div>
                <div className="formulario-field pt-1">
                    <button
                        type="button"
                        className="btn btn-outline-dark mt-4 ml-auto"
                        onClick={reclasificacion.AbrirModal}
                        style={{ maxWidth: "200px" }}
                    >
                        Agregar pacas
                    </button>
                </div>
            </div>
        </div>
    );
};

const SeccionSobrante = ({ sobrante }) => {
    return (
        <div className="d-flex flex-column w-100 gap-10">
            <h5 className="text-sm">Sobrante en reclasificación</h5>

            <div className="formulario-fields-row w-100 gap-1rem flex-wrap my-0">
                <div className="formulario-field">
                    <label className="text-nowrap">Pacas formadas</label>
                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={
                            formatDisplayNumber(sobrante.pacas) +
                            " (" +
                            formatDisplayNumber(sobrante.totalKg) +
                            " kg)"
                        }
                    />
                </div>
                <div className="formulario-field">
                    <label className="text-nowrap">Sobrante agregado</label>
                    <div className="w-auto">
                        <PalletsReclasificacion
                            pallets={sobrante.items}
                            align="start"
                        />
                    </div>
                </div>
                <div className="formulario-field pt-1">
                    <button
                        type="button"
                        className="btn btn-outline-dark mt-4 ml-auto"
                        onClick={sobrante.AbrirModal}
                        style={{ maxWidth: "200px" }}
                    >
                        Agregar sobrante
                    </button>
                </div>
            </div>
        </div>
    );
};

export const ContenidoReclasificacion = ({
    hayProductoSeleccionado,
    reclasificacion,
    sobrante,
}) => {
    // no hay nada de reclasificación (pallets ni sobrante) en el turno
    if (!reclasificacion.global && !sobrante.global) {
        return null;
    }

    const hayDisponibleProducto =
        reclasificacion.disponibleProducto > 0 ||
        sobrante.disponibleProducto > 0;

    return (
        <div className="d-flex flex-column pt-3 pb-3 border-top border-bottom w-100 mb-3 gap-2rem">
            {!hayProductoSeleccionado ? (
                <span>Seleccione un producto para agregar reclasificación</span>
            ) : !hayDisponibleProducto ? (
                <span>Este producto no tiene reclasificación disponible</span>
            ) : (
                <React.Fragment>
                    {reclasificacion.disponibleProducto > 0 && (
                        <SeccionReclasificacion
                            reclasificacion={reclasificacion}
                        />
                    )}

                    {sobrante.disponibleProducto > 0 && (
                        <SeccionSobrante sobrante={sobrante} />
                    )}
                </React.Fragment>
            )}
        </div>
    );
};
